import script from "./Trial20710.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trial20710.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__